import { Injectable } from "@/di/injectable";
import { $config } from "@/settings";

export enum HttpMethod {
  Post = "POST",
  Options = "OPTIONS",
  Get = "GET",
  Head = "HEAD",
  Put = "PUT",
  Delete = "DELETE",
  Trace = "TRACE",
  Connect = "CONNECT",
}

interface ResponseData<T> {
  body?: {
    content: T;
    result: number;
    desc: string;
  };
  code?: number;
  data?: T;
}

@Injectable({ scope: "singleton" })
export class HttpService {
  sxhr<P, T>(options: {
    path: string;
    url?: string;
    data?: P;
    method?: HttpMethod;
    keepalive?: boolean;
  }): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      fetch(
        `${options.url != undefined ? options.url : $config.apiUrl}${options.path ? "/" + options.path : ""}`,
        {
          method:
            options.method != undefined ? options.method : HttpMethod.Post,
          headers: {
            "Content-Type": "application/json",
          },
          keepalive: options.keepalive,
          body:
            options.data !== undefined
              ? typeof options.data === "string"
                ? options.data
                : JSON.stringify(options.data)
              : undefined,
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          const responseData: ResponseData<T> = response as ResponseData<T>;
          if (responseData.body) {
            if (responseData.body.result == 0) {
              resolve(responseData.body.content);
            } else {
              reject(responseData.body);
            }
          } else if (
            responseData.code != undefined ||
            responseData.code === 0 ||
            responseData.code === 200
          ) {
            if (responseData.code === 0 || responseData.code === 200) {
              resolve(responseData.data as T); // 显式转换类型
            } else {
              reject(responseData);
            }
          }
          resolve(response as T);
        })
        .catch((error) => {
          console.log("error", error);
          reject(error);
        });
    });
  }

  sk_sxhr<P, T>(
    options: {
      path: string;
      url?: string;
      data?: P;
      method?: HttpMethod;
    },
    url: string,
  ): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.sxhr<undefined, T>({
        path: "",
        url: url,
        method: HttpMethod.Get,
      }).then(
        (res) => {
          resolve(res);
        },
        () => {
          this.sxhr<P, T>(options).then(resolve).catch(reject);
        },
      );
    });
  }
}
